import React, { useState} from 'react';
import Modal from 'react-bootstrap/Modal';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import OtpInputModal from '../Company/OtpInputModal';
import ProjectsService from '../../Services/ProjectsService';
import './ChangePhoneNumber.css';
import './AllTabs.css';
import { toast } from 'react-toastify';
import UserService from '../../Services/UserService';
const ChangePhoneNumber = ({ setPage }) => {
  
  const [isUpdateButtonActive, setIsUpdateButtonActive] = useState(false);
  const [modalShow, setModalShow] = React.useState(false);
  const [OtpModalOpen, setOtpModalOpen] = useState(false);
  const [OtpDataFromModal,setOtpDataFromModal] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [flagSelected, setFlagSelected] = useState(false);

  const handleOtp = (OtpDataToProject) => {
    setOtpDataFromModal(OtpDataToProject);
  }
 
  console.log("phoneNumber ---"+phoneNumber)
    const userDetailsObject = {
  mobile: phoneNumber || ""
};
   
     var otpInputModelOpenendForAction = '';



      async function verifyOtp(OtpDataFromModal){
  
        if(OtpDataFromModal.length!==0){
          console.log(OtpDataFromModal)
          OtpDataFromModal  = Number(OtpDataFromModal.join(''));
          console.log("otp:"+OtpDataFromModal)
          console.log("userDetailsObject"+userDetailsObject.mobile);
          await UserService.activateMobileNumber(OtpDataFromModal).then(async(response) => {
            await UserService.refereshUser();
                setIsUpdateButtonActive(false); 
                setOtpModalOpen(false);
                toast.success(response.data.message);
                setModalShow(true);
                setTimeout(() => { 
                  window.location.reload();
              }, 4000);
            }).catch(error =>{
                console.log(error);
                setOtpModalOpen(true);
                // Check if it's an APIM error - let global interceptor handle those
                if (error.response?.data?.code?.startsWith('APIM-')) {
                  console.log('APIM error caught in ChangePhoneNumber, letting global interceptor handle it:', error.response.data.code);
                } else {
                  // Only show toast for non-APIM errors
                  toast.error(error.response?.data?.message || 'An error occurred while activating mobile number');
                }
            })
         }
        
          }

     
      function MyVerticallyCenteredModal(props) {
        return (
          <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            animation={false}
            backdrop='static' 
            keyboard="False"
            dialogClassName='my-modal'
          >
            <Modal.Header className='modal-header'>
              <Modal.Title id="contained-modal-title-vcenter">
              Confirmation Of Account Creation
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className='modal-body'>
              <p>
              Confirmation Of Changes Password Request</p>
            </Modal.Body>
            <Modal.Footer>
            <button className="ui button comm-button-style primary" >LOGOUT</button>
            </Modal.Footer>
          </Modal>
        );
      }
      async function handleSubmit() {
        if (!phoneNumber) {
  toast.error("Please enter a phone number");
  return;
}

if (!isValidPhoneNumber(phoneNumber)) {
  toast.error("Please enter a valid phone number");
  return;
}
        console.log("HI FROM CHange phone number")
        setIsUpdateButtonActive(true);
        console.log("userDetailsObject.phoneNumber"+userDetailsObject.phoneNumber)
        otpInputModelOpenendForAction = "changePhonenumber";
        
        //first call new mobile service
        try {
          const newMobileServiceResponse=await UserService.updateMobileNumber(userDetailsObject);
          if(newMobileServiceResponse){
            try {
              const response = await ProjectsService.getStrongConfirmationCode("POST",null,"changePhoneNumber",null,null,null)
          if (response && response.data.channel === "SMS") {
              otpInputModelOpenendForAction = "changePhoneNumber";
              
              setOtpModalOpen(true);
             
            }
         
              
          } catch (error) {
              console.log(error);
          }
          }
        } catch (error) {
          console.log(error)
        }

       
      }
      const resendOtp = async() => {
      await ProjectsService.getStrongConfirmationCode("POST",null,"changePhoneNumber",null,null,null);
      }
      
    return(
    <>
     <div className="phone-number-container">
      <div className="phone-number-content">
        <div className="ui bottom attached tab segment active change-phone-number-mpc" data-tab="changePhoneNumber">
          <ul className="pass-elements">
            <li>
              <h3>Change Phone Number</h3>
            </li>
            <li>
              <div className="phone-number-container">
                <div className="contact-num-wrap">
                  <div className="country-code-w">
                    <div className={`phone-input-wrapper ${flagSelected ? 'with-placeholder' : ''}`}>  
                      <PhoneInput
  international
  value={phoneNumber}
  onChange={(value) => {
    setPhoneNumber(value || '');
    setFlagSelected(true);
  }}
  placeholder="Enter phone number"
/>
                    </div>
                  </div>
                </div>
              </div>
              <span className="required-field-op">(Required)</span>
              <span className="form-error error-message-show" style={{visibility: 'hidden'}}>Mobile number is invalid</span>
            </li>     
            <li>
              <div className="apim-pop-button-w comm-button-wrap">
                <button className="ui button comm-button-style primary apim-reset-pass-btn btn-disable" id="updateBtn"  onClick={handleSubmit} disabled={!phoneNumber || !isValidPhoneNumber(phoneNumber)}>Update</button>
                <button className="ui button comm-button-style secondary custom-loader" id="loadingBtn" style={{display: 'none'}}>
                  <i className="icon-plus iconLoader" />
                  Changing phone Number..
                </button>
                <button className="ui button comm-button-style secondary apim-pop-button-cancel" id="cancelBtn"
                  onClick={() => {
                    setPhoneNumber('');
                    setFlagSelected(false);
                    setIsUpdateButtonActive(false);
                    setPage('myProfile');
                  }}
                >
                  Cancel
                </button>
              </div>
            </li>
          </ul>
        </div>
      </div>
      {OtpModalOpen &&<OtpInputModal ModalHeading={""} setOpenOtpModal={setOtpModalOpen} handleOtp={handleOtp} value={OtpDataFromModal}  verifyOtp={verifyOtp} credentialRecord={""} otpInputModelOpenendForAction={otpInputModelOpenendForAction} newMobile={userDetailsObject.mobile} resendOtp={resendOtp}/>}
     </div>
    </>
    )
}
export default ChangePhoneNumber;